import React from 'react';
import { formatSetupStatus } from '../../utils/year2SquadSetup';
import './year2SquadCreator.css';

export default function Year2CohortCards({
  schoolName,
  cohorts,
  loading,
  onBack,
  onOpenCohort,
}) {
  if (loading) {
    return (
      <div className="placeholder-card">
        <p>Loading Year 2 cohorts…</p>
      </div>
    );
  }

  return (
    <div>
      <button type="button" className="btn-form-toggle-outlined" onClick={onBack} style={{ marginBottom: '16px' }}>
        ← Back to schools
      </button>

      <div className="year2-page-header">
        <h2 className="year2-page-title">{schoolName}</h2>
        <p className="year2-page-subtitle">
          {cohorts.length} Year 2 cohort{cohorts.length === 1 ? '' : 's'} — select a cohort to configure squads
        </p>
      </div>

      {cohorts.length === 0 ? (
        <div className="placeholder-card">
          <p>No Year 2 cohorts available for this school.</p>
        </div>
      ) : (
        <div className="year2-cohort-grid">
          {cohorts.map((cohort) => (
            <div key={cohort.cohort_id} className="year2-cohort-card" style={{ cursor: 'default' }}>
              <div className="year2-card-header">
                <div>
                  <h3 className="year2-card-title">{cohort.cohort_name}</h3>
                  <p style={{ margin: 0, fontSize: '12px', color: 'var(--text-muted)' }}>
                    {schoolName}
                  </p>
                </div>
                <span className={`year2-status-pill ${cohort.setup_status}`}>
                  {formatSetupStatus(cohort.setup_status)}
                </span>
              </div>

              <div className="year2-metric-row" style={{ marginBottom: '14px' }}>
                <div className="year2-metric-chip">
                  <div className="year2-metric-value">{cohort.student_count}</div>
                  <div className="year2-metric-label">Students</div>
                </div>
                <div className="year2-metric-chip">
                  <div className="year2-metric-value">
                    {cohort.setup_status === 'blocked' ? '—' : cohort.required_squads}
                  </div>
                  <div className="year2-metric-label">Squads</div>
                </div>
              </div>

              {cohort.blocked_message && (
                <p style={{ fontSize: '12px', color: '#b91c1c', margin: '0 0 14px', lineHeight: 1.45 }}>
                  {cohort.blocked_message}
                </p>
              )}

              <button
                type="button"
                className={cohort.setup_status === 'blocked' ? 'btn-form-toggle-outlined' : 'btn-primary-action'}
                style={{ width: '100%' }}
                onClick={() => onOpenCohort(cohort)}
              >
                {cohort.action_label}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}